<template>
  <div class="gong-gao">
    <div class="gonggao">
      <!-- <div class="gonggao-title">
        三星堆公告
      </div> -->
      <div class="gonggao-body ">
          <div @mouseover="clearanim" @mouseout="openanim" :class="{'anim':animation==true,' animhover':animation==false}"  v-for="(item,index) in news2" :key="index">
            <span class="Aellipsis1"  @click="goDetail(item)">{{item.title}}</span>
          </div>
          <!-- <span class="checkmore" @click="goMore">查看更多</span> -->
      </div>
    </div>

  </div>
</template>

<script>
export default {
    props: {
        news: {
            type: Array,
            default () {
                return [
                    {news_id: 1, title: '121f212', date: '2020-01-01'},
                    {news_id: 2, title: '1212e12', date: '2020-01-01'},
                    {news_id: 3, title: '121sf212', date: '2020-01-01'},
                    {news_id: 4, title: '1212d12', date: '2020-01-01'}
                ]
            }
        }
    },
    data () {
        return {
            animation: false,
            i: 0,
            news2: []
        }
    },
    created () {
        this.$nextTick(() => {
            this.$watch('news', (newval, oldval) => {
                this.news2 = newval
                this.news2 = newval.slice(0)
                if (newval.length > 1) {
                    this.timer = setInterval(() => {
                        this.up()
                    }, 2000)
                }
            })
        })
    },
    methods: {
        clearanim () {
            clearInterval(this.timer)
        },
        openanim () {
            if (this.news.length > 1) {
                this.timer = setInterval(() => {
                    this.up()
                }, 2000)
            }
        },
        up () {
            this.animation = true
            setTimeout(() => {
                let arr = this.news2.splice(this.i, 1)
                this.news2.push(...arr)
                this.animation = false
            }, 500)
        },
        goDetail (item) {
            this.$router.push({path: '/zh-CN/advisoryDetail', query: {knowledge_id: item.news_id, zhtype: '相关公告', navIndex: 0}})
        }
    }

}

</script>
<style scoped lang='scss'>
.Aellipsis1{
   overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: nowrap;
}
  .gong-gao{
    width: 1240px;
    height: 50px;
    overflow: hidden;
    margin: auto;
    position: absolute;
    z-index: 2;
    left: 50.08%;
    transform: translate(-49.4%, -50px);
    // pointer-events: none;
    background: #00000080;
  }
  .gonggao{
    width: 100%;
    height: 100%;
    display:flex;
    color: #fff;
    .gonggao-title{
      width: 10%;
      background: #3a7062;
      text-align: center;
      font-size: 18px;
      display:flex;
      align-items: center;
      justify-content: center;
    }
    .gonggao-body{
      width: 70%;
      // background: #00000080;
      padding-left: 20px;
      padding-right: 20px;
      font-size: 16px;
      height: 100%;
     position: relative;

     .checkmore{
       position: absolute;
       right: 15px;
       top: 15px;
       cursor: pointer;
     }
      >div{
        height: 100%;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        >span:nth-child(1){
          display: inline-block;
          width: 80%;
        }
        >span:nth-child(2){
          text-decoration:underline;
        }
      }

    }
  }
  .anim{
     animation: up 0.5s cubic-bezier(.51,.58,.87,.84) 0s 1 normal forwards;
    //  animation: name duration timing-function delay iteration-count direction fill-mode;

  }

  @keyframes up {
    from{
      transform: translateY(0);
    }
    to{
      transform: translateY(-100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gonggao.vue